import 'core-js/es/symbol';
import 'core-js/es/object';
import 'core-js/es/function';
import 'core-js/es/parse-int';
import 'core-js/es/parse-float';
import 'core-js/es/number';
import 'core-js/es/math';
import 'core-js/es/string';
import 'core-js/es/date';
import 'core-js/es/array';
import 'core-js/es/regexp';
import 'core-js/es/map';
import 'core-js/es/weak-map';
import 'core-js/es/set';

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// IE dosent support remove for Node so we add it here
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

// IE dosent support append for Node so we add it here
/**
 * ChildNode.append() polyfill
 * https://gomakethings.com/adding-an-element-to-the-end-of-a-set-of-elements-with-vanilla-javascript/
 * @author Chris Ferdinandi
 * @license MIT
 */
(function (elem) {
  // Check if element is a node
  // https://github.com/Financial-Times/polyfill-service
  const isNode = function (object) {
    // DOM, Level2
    if (typeof Node === 'function') {
      return object instanceof Node;
    }

    // Older browsers, check if it looks like a Node instance)
    return object
			&& typeof object === 'object'
			&& object.nodeName
			&& object.nodeType >= 1
			&& object.nodeType <= 12;
  };

  // Add append() method to prototype
  for (let i = 0; i < elem.length; i++) {
    if (!window[elem[i]] || 'append' in window[elem[i]].prototype) continue;
    window[elem[i]].prototype.append = function () {
      const argArr = Array.prototype.slice.call(arguments);
      const docFrag = document.createDocumentFragment();

      for (let n = 0; n < argArr.length; n++) {
        docFrag.appendChild(isNode(argArr[n]) ? argArr[n] : document.createTextNode(String(argArr[n])));
      }

      this.appendChild(docFrag);
    };
  }
}(['Element', 'CharacterData', 'DocumentType']));

// IE dosent support ClassList, so add it here
// https://stackoverflow.com/a/48501981
if (!Object.getOwnPropertyDescriptor(Element.prototype, 'classList')) {
  if (HTMLElement && Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'classList')) {
    Object.defineProperty(Element.prototype, 'classList', Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'classList'));
  }
}
